import React from 'react'
import { Box, Typography } from '@mui/material'
import InfoRoundedIcon from '@mui/icons-material/InfoRounded'
import Callout from '../Common/callout/Callout'
import { defaultPalette } from '../../theme/idsTheme'

const RequiredExpertCallout: React.FC = () => (
    <Callout color={defaultPalette.primary.main} icon={<InfoRoundedIcon />} iconAlignment="flex-start">
        <Box>
            <Typography>
                Cette section vous permet de gérer le réseau de téléconsultants de votre établissement. Vous pouvez
                ainsi "enrôler" les médecins avec lesquels vous travaillez fréquemment, en présentiel ou en distanciel,
                afin qu'ils rejoignent votre réseau de télémédecine. <br />
                <br />
                <br /> Cet enrôlement se déroule en plusieurs étapes :
            </Typography>
            <ol>
                <li>Ajouter une fiche téléconsultant, utilisez de préférence la recherche RPPS ;</li>
                <li>
                    Inviter le téléconsultant, celui-ci reçoit alors un courriel et un sms lui présentant le service,
                    idéalement prévenez le en amont de cette invitation ;
                </li>
                <li>Le téléconsultant accepte ou décline votre invitation ;</li>
                <li>
                    Le téléconsultant reçoit toutes les informations nécessaires pour utiliser la plateforme de
                    télémédecine TokTokDoc ;
                </li>
                <li>Vous pouvez programmer des actes de télémédecine avec le téléconsultant.</li>
            </ol>
        </Box>
    </Callout>
)

export default RequiredExpertCallout
